import React, { JSX, useState } from "react";

import { PointedText } from "../models";
import { StickyContainer } from "../sticky/StickyContainer";
import { useSettings } from "../utils/settings";
import { useTweaks } from "../utils/TweakProvider";
import { PlayableTitle } from "./audio/PlayableTitle";
import { TonePlayer } from "./audio/TonePlayer";
import { Chant } from "./Chant";
import { getTextFromPsalmRef, PsalmRef } from "./utils";

export const PsalmSection: React.FC<{
    sectionRef: PsalmRef;
    pointedPsalmSection: PointedText;
    title: JSX.Element | string;
    tones: string[];
    exportLines?: boolean;
}> = (props) => {
    const { sectionRef, pointedPsalmSection, title, tones, exportLines } =
        props;

    const { settings, setSetting } = useSettings();

    const [modal, setModal] = useState(<></>);

    const { tweaks, setTweak } = useTweaks();

    const selectedTone = tweaks[getTextFromPsalmRef(sectionRef)] ?? tones[0];

    const id =
        sectionRef.number +
        (sectionRef.type === "section"
            ? `-${sectionRef.firstVerse}-${sectionRef.lastVerse}`
            : "");

    return (
        <div style={{}}>
            <StickyContainer id={id}>
                <PlayableTitle
                    id={id}
                    title={title}
                    player={
                        <TonePlayer
                            tones={tones}
                            id={
                                sectionRef.type === "full"
                                    ? `${sectionRef.number}`
                                    : `${sectionRef.number}:${sectionRef.firstVerse}-${sectionRef.lastVerse}`
                            }
                            onSetModal={(id, element) => setModal(element)}
                            selectedTone={selectedTone}
                            onSetSelectedTone={(tone) => {
                                setTweak(getTextFromPsalmRef(sectionRef), tone);
                            }}
                        />
                    }
                />
                <Chant
                    pointedText={pointedPsalmSection}
                    boldMode={settings.psalmsBold}
                    dropCap={true}
                    exportLines={exportLines}
                    tone={selectedTone}
                />
            </StickyContainer>
            {modal}
        </div>
    );
};
